/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { FetchPolicy, useQuery } from '@apollo/client'

import { GET_GROUPS, GetGroupsQuery, GetGroupsQueryVariables } from '@/graphql'

type Props = {
  fetchPolicy: FetchPolicy
}

const useDaiGroups = (props?: Props) => {
  const {
    data: groupsData,
    loading,
    error,
  } = useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GET_GROUPS, {
    fetchPolicy: props?.fetchPolicy ?? 'cache-and-network',
  })

  const groups = groupsData?.groups.results || []

  const adminGroup = groups.find(group => group.isOwner)

  return {
    groups,
    loading,
    error,
    adminGroup,
  }
}

export default useDaiGroups
